module.exports = __webpack_public_path__ + "Flama-LightItalic.ttf?3d2ad2c65353afaa8706a9e8f0ce4d01";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-LightItalic.ttf
// module id = 928
// module chunks = 0